export default "__VITE_ASSET__5b2cc742__"